import { Routes, Route, useLocation } from "react-router-dom";
import "./styles/App.css";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Terms from "./pages/Terms";
import Pricing from "./pages/Pricing";
import Footer from "./components/Footer";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import NotFound from "./components/NotFound";
import ScrollToTop from "./components/ScrollToTop";
import ApiDocs from "./pages/ApiDocs"; 

function App() {
  const location = useLocation();
  const isNotFoundPage = location.pathname !== "/" && 
    location.pathname !== "/pricing" && 
    location.pathname !== "/terms-conditions" && 
    location.pathname !== "/privacy-policy" &&
    location.pathname !== "/api-docs";

  return (
    <>
      {!isNotFoundPage && <Navbar />}
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/terms-conditions" element={<Terms />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/api-docs" element={<ApiDocs />} /> 
        <Route path="*" element={<NotFound />} />
      </Routes>
      {!isNotFoundPage && <Footer />}
    </>
  );
}

export default App;